module.exports = __webpack_public_path__ + "assets/img/extractionTarot_Tit2.24b029e5.png";